import React, { useEffect, useRef, useState } from 'react';
import './SobreNosotros.css';
import MapaUruguay from '../assets/mapa5.svg';

const DURATION_SLOW = 3800;

const SobreNosotros = () => {
  const statsRef = useRef(null);
  const mapRef = useRef(null);
  const hasAnimatedStatsRef = useRef(false);
  const hasAnimatedHectaresRef = useRef(false);
  const [mapVisible, setMapVisible] = useState(false);
  const [stats, setStats] = useState({ anos: 0, generaciones: 0, premios: 0 });
  const [counts, setCounts] = useState({ canelones: 0, sanJose: 0, montevideo: 0 });

  useEffect(() => {
    const el = statsRef.current;
    if (!el) return;
    const run = () => {
      if (hasAnimatedStatsRef.current) return;
      hasAnimatedStatsRef.current = true;
      const target = { anos: 40, generaciones: 3, premios: 10 };
      const start = performance.now();
      const tick = (now) => {
        const progress = Math.min((now - start) / DURATION_SLOW, 1);
        const eased = 1 - Math.pow(1 - progress, 2.5);
        setStats({ 
          anos: Math.round(target.anos * eased), 
          generaciones: Math.round(target.generaciones * eased), 
          premios: Math.round(target.premios * eased) 
        });
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    const obs = new IntersectionObserver(
      (entries) => { if (entries.some((e) => e.isIntersecting)) run(); }, 
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    const animateCounts = () => {
      if (hasAnimatedHectaresRef.current) return;
      hasAnimatedHectaresRef.current = true;
      const target = { canelones: 359, sanJose: 51, montevideo: 16 };
      const startTime = performance.now();
      const tick = (now) => {
        const progress = Math.min((now - startTime) / DURATION_SLOW, 1);
        const eased = 1 - Math.pow(1 - progress, 2.5);
        setCounts({ 
          canelones: Math.round(target.canelones * eased), 
          sanJose: Math.round(target.sanJose * eased), 
          montevideo: Math.round(target.montevideo * eased) 
        });
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    const observer = new IntersectionObserver(
      (entries) => { if (entries.some((entry) => entry.isIntersecting)) animateCounts(); }, 
      { threshold: 0.2 }
    );
    if (statsRef.current) observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const el = mapRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => { if (entries.some((e) => e.isIntersecting)) setMapVisible(true); }, 
      { threshold: 0.2 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="sobre-nosotros-section" id="sobre-nosotros">
      <div className="container">
        <div className="sobre-header text-center">
          <div className="badge-outline">DESDE 1977</div>
          <h2 className="section-title">SOBRE NOSOTROS</h2>
          <p className="section-subtitle">Tres generaciones de tradición vitivinícola</p>
        </div>

        <div className="about-grid">
          <div className="about-left">
            <div className="stats-container" ref={statsRef}>
              <div className="stat-item">
                <div className="stat-number">{stats.anos}<span className="plus">+</span></div>
                <div className="stat-label">AÑOS</div>
              </div>
              <div className="stat-divider" />
              <div className="stat-item">
                <div className="stat-number">{stats.generaciones}</div>
                <div className="stat-label">GENERACIONES</div>
              </div>
              <div className="stat-divider" />
              <div className="stat-item">
                <div className="stat-number">{stats.premios}<span className="plus">+</span></div>
                <div className="stat-label">PREMIOS</div>
              </div>
            </div>
            <div className="text-center">
              <a href="/historia" className="btn-outline">DESCUBRE NUESTRO LEGADO</a>
            </div>
          </div>

          <div className={`about-right ${mapVisible ? 'map-visible' : ''}`} ref={mapRef}>
            <img src={MapaUruguay} alt="Mapa de Uruguay - Viñedos" className="mapa-uruguay" />
            <div className="region-text">
              <div className="region-line region-line--primary">
                <span className="region-line-name">Canelones</span>
                <span className="region-line-sep">:</span>
                <span className="region-line-value"><span className="region-line-number">{counts.canelones}</span> Hectáreas</span>
              </div>
              <div className="region-line region-line--primary">
                <span className="region-line-name">San José</span>
                <span className="region-line-sep">:</span>
                <span className="region-line-value"><span className="region-line-number">{counts.sanJose}</span> hectáreas</span>
              </div>
              <div className="region-line region-line--accent">
                <span className="region-line-name">Montevideo</span>
                <span className="region-line-sep">:</span>
                <span className="region-line-value"><span className="region-line-number">{counts.montevideo}</span> hectáreas</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SobreNosotros;
